import { createAsyncThunk } from '@reduxjs/toolkit';
import { PlaidApi, PlaidRequestParams, SetBankAccountsError } from 'api/PlaidApi';

export const createSendPlaidSuccessThunk = (api: PlaidApi) =>
  createAsyncThunk('plaid/sendPlaidSuccess', async (payload: PlaidRequestParams, thunkApi) => {
    try {
      await api.sendPlaidSuccess(payload.applicationId!, payload);
    } catch (error: any) {
      return thunkApi.rejectWithValue({ status: error.responseStatus, ...error.data } as SetBankAccountsError);
    }
  });

export default createSendPlaidSuccessThunk;
